import {
  CLEAR_ACCOUNT_SETTINGS,
  RECEIVE_ACCOUNT_SETTINGS,
  RECEIVE_ACCOUNT_SETTINGS_FAILED
} from "../actions/accountSettings";

const initialState = {};

const accountSettings = (state = initialState, action) => {
  switch (action.type) {
    case RECEIVE_ACCOUNT_SETTINGS:
      return Object.assign({}, state, action.accountSettings);
    case RECEIVE_ACCOUNT_SETTINGS_FAILED:
    case CLEAR_ACCOUNT_SETTINGS:
      return initialState;
    default:
      return state;
  }
};

export default accountSettings;



// WEBPACK FOOTER //
// ./src/reducers/accountSettings.js